import ApiService from '../../services/api.service'
import { AcceptedUserAgreementModel } from '../models'

export default {
  async acceptUserAgreement(acceptedUserAgreement: AcceptedUserAgreementModel): Promise<void> {
    await ApiService.post(`${ApiService.backendEnvironmentConfiguration().userSettingsApi}/Documents/acceptDocument`, acceptedUserAgreement)
  },
}
